"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TerminologyCapabilities_Version = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_TerminologyCapabilities_Filter_1 = require("./RTTI_TerminologyCapabilities_Filter");
exports.RTTI_TerminologyCapabilities_Version = t.recursion('ITerminologyCapabilities_Version', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        code: t.string,
        _code: RTTI_Element_1.RTTI_Element,
        isDefault: t.boolean,
        _isDefault: RTTI_Element_1.RTTI_Element,
        compositional: t.boolean,
        _compositional: RTTI_Element_1.RTTI_Element,
        language: t.array(RTTI_code_1.RTTI_code),
        _language: t.array(RTTI_Element_1.RTTI_Element),
        filter: t.array(RTTI_TerminologyCapabilities_Filter_1.RTTI_TerminologyCapabilities_Filter),
        property: t.array(RTTI_code_1.RTTI_code),
        _property: t.array(RTTI_Element_1.RTTI_Element)
    });
});
//# sourceMappingURL=RTTI_TerminologyCapabilities_Version.js.map